// Entry point for the build script in your package.json
import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import "./controllers";

ActiveStorage.start();

// Fire PageView on every Turbo navigation (including first load).
// Pixel snippets in <head> only init -- auto-PageView is disabled
// to prevent double-firing on Turbo Drive navigation.
/* global gtag, fbq */
document.addEventListener("turbo:load", () => {
  if (typeof gtag === "function") {
    gtag("event", "page_view", {
      page_path: window.location.pathname,
      page_title: document.title,
    });
  }

  if (typeof fbq === "function") {
    fbq("track", "PageView");
  }

  if (window._uxa) {
    window._uxa.push(["trackPageview", window.location.pathname]);
  }
});
